module.exports = __webpack_public_path__ + "static/Form-Letter-59e1cd553c4b5c626287971e4f537eb1.png";